<template>
	<div class="grid-x row">
		<div class="cell small-12 columns">
			Empty
		</div>
	</div>
</template>


<script>
export default {
	props: ['data'],
	mounted() {
		console.log('empty block loaded: ' + this.data.acf_fc_layout)
	}
}
</script>